import React, { useEffect, useState } from 'react'
import styled from 'styled-components'
import config from '../config'
import EntrancePages from '../containers/EntrancePages'
import { SIZES } from '../styles/theme'

const Page = styled.div`
  min-height: 100vh;
  width: 100vw;
  text-align: center;
  background: #f2f1f1;

  #content {
    position: absolute;
    top: 0;
    width: 100%;
  }

  #header {
    .time-wrapper {
      display: flex;
      justify-content: center;
      align-items: center;
      text-transform: uppercase;
      position: absolute;
      top: 2%;
      left: 10%;
      right: 10%;
      z-index: 1000;

      ${SIZES.mobile} {
        flex-wrap: wrap;
        top: 62%;
        left: 10%;
        right: 10%;
        @media screen and (min-width: 768px) {
          top: 40%;
          left: 10%;
          right: 10%;
        }
      }

      .time-card {
        border-radius: 18px;
        border: 4px solid #fff;
        background: rgb(255, 255, 255);
        background: linear-gradient(rgba(255, 255, 255, 1) 0%, rgba(242, 241, 241, 1) 70%, rgba(180, 179, 179, 1) 100%);
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        min-width: 120px;
        width: 10vw;
        min-height: 120px;
        height: 10vh;
        margin: 0 3%;
        margin-top: 5px;
        padding-top: 10px;
        color: #454852;
        box-shadow: 0 5px 4px -4px #000000;

        p {
          margin-top: 6px;
          margin-bottom: 6px;
          font-weight: 500;
          font-size: 1rem;
        }
        h2 {
          margin-top: 0;
          font-weight: 700;
          font-size: 2.5rem;
        }

        ${SIZES.mobile} {
          border-radius: 18px;
          margin: 0 2%;
          margin-top: 12px;
          border: 4px solid #fff;
          min-height: 11vh;
          min-width: 110px;
          width: 70px;
          height: 60px;
          @media screen and (min-width: 768px) {
            min-height: 10vh;
            min-width: 120px;
            width: 70px;
            height: 60px;
          }
          p {
            margin-top: 6px;
            margin-bottom: 2px;
            font-size: 0.8rem;
          }
          h2 {
            text-align: center;
            margin-top: -1px;
            font-weight: 700;
            font-size: 1.5rem;
          }
        }
      }
    }
  }

  .btn {
    display: block;
    margin: 8px 0;
    background: #143e8b;
    color: #ffffff;
    font-weight: 500;
    padding: 4px 24px;
    border-radius: 32px;
    border: 2px solid white;
  }
  .timeup {
    color: white;
    font-weight: 600;
    font-size: 24px;
  }
  #bg {
    background-image: url(${config.assets.countdown.portrait});
    background-size: cover;
    bottom: 0;
    padding: 0;
    min-height: 100%;
    position: relative;
    /* height: calc(100vh - 200px); */
    img#portrait {
      display: none;
    }
    img#landscape {
      display: block;
    }
    ${SIZES.mobile} {
      img#portrait {
        display: block;
        margin: 0 auto;
      }
      img#landscape {
        display: none;
      }
    }
  }
  #mobile-hide {
    display: block;
    position: absolute;
    width: 50%;
    top: 10%;
    right: 0%;

    ${SIZES.mobile} {
      display: none;
    }
  }
`

export default function CountdownPage() {
  const calculateTimeLeft = () => {
    const { year, month, day, hour, minute } = config.EVENT_START_TIME
    const difference = +new Date(year, month - 1, day, hour, minute, 0, 0) - +new Date()
    let timeLeft = {}

    if (difference > 0) {
      timeLeft = {
        days: Math.floor(difference / (1000 * 60 * 60 * 24)),
        hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((difference / 1000 / 60) % 60),
        seconds: Math.floor((difference / 1000) % 60),
      }
    }

    return timeLeft
  }

  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft())

  useEffect(() => {
    setTimeout(() => {
      setTimeLeft(calculateTimeLeft())
    }, 1000)
  })

  const timerComponents = []

  Object.keys(timeLeft).forEach((interval) => {
    if (isNaN(timeLeft[interval])) {
      return
    }

    timerComponents.push(
      <div className="time-card" key={interval}>
        <p>{interval}</p>
        <h2>{timeLeft[interval]}</h2>
      </div>
    )
  })
  const refreshPage = () => {
    window.location.reload()
  }

  const eventStarted = !timerComponents.length

  if (eventStarted) {
    return <EntrancePages />
  }

  return (
    <Page>
      <div id="content">
        <div id="header">
          <div className="time-wrapper">
            {timerComponents.length ? (
              timerComponents
            ) : (
              <span className="timeup">
                Time's up!
                <button className="btn" onClick={refreshPage}>
                  Enter Event
                </button>
              </span>
            )}
          </div>
        </div>
        <div id="bg">
          <img id="landscape" src={config.assets.countdown.landscape} width="100%" alt="background" />
          <img id="portrait" src={config.assets.countdown.portrait} width="100%" alt="background" />
        </div>
      </div>
    </Page>
  )
}
